module.exports = "images/logo192.png";